import { FC, useMemo } from 'react'
import { useLocation } from 'react-router'
import { useAppSelector } from '../../../redux/hooks'
import { ePrivateRoutes } from '../../../routes/e-routes'
import { selectIsTrialExpired } from '../../../utils/is-trial-expired'

interface ILCTrialGuardProps {
  children: React.ReactNode
}

// Routes that are allowed during trial expiration
const ALLOWED_ROUTES_DURING_TRIAL_EXPIRATION = [
  ePrivateRoutes.PURCHASE,
  // Only allow purchase - trial users don't need settings access
]

export const LCTrialGuard: FC<ILCTrialGuardProps> = ({ children }) => {
  const location = useLocation()
  const isTrialExpired = useAppSelector(selectIsTrialExpired)

  const isCurrentRouteAllowed = useMemo(() => {
    return ALLOWED_ROUTES_DURING_TRIAL_EXPIRATION.some((route) => location.pathname.startsWith(route))
  }, [location.pathname])

  // If trial is not expired, show children normally
  if (!isTrialExpired) {
    return <>{children}</>
  }

  // If trial is expired but current route is allowed, show children
  if (isCurrentRouteAllowed) {
    return <>{children}</>
  }

  // If trial is expired and current route is not allowed, redirect to purchase
  // This will be handled by the overlay component
  return <>{children}</>
}
